import { restApiMP } from "@plannel/services/utils/rest-api";

const get = params => {
  return restApiMP.post("/api/mp-demand", params);
};

const getMpDemandVersions = () => {
  return restApiMP.get("/api/mp-demand/versions");
}

const getMpOrdersByDemand = (params) => {
  return restApiMP.get("/api/mp-demand/orders", { params });
}

const getRtf = (body) => {
  return restApiMP.post("/api/mp-demand/rtf", body);
}

const getMpDemandVersionsHavingMpVersion = () => {
  return restApiMP.get("/api/mp-demand/versions/having-mp-version");
}

const mpDemandService = {
  get,
  getMpDemandVersions,
  getMpOrdersByDemand,
  getRtf,
  getMpDemandVersionsHavingMpVersion
};

export default mpDemandService;